import { css } from "@emotion/react";
import React, { createContext, useContext } from "react";
import { InputDisplayValue } from "../InputBase/InputDisplayValue";

export const NumberFieldInputWrapperContext = createContext<string | undefined>(
  undefined,
);

export const NumberFieldInputWrapper = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const value = useContext(NumberFieldInputWrapperContext);
  return (
    <div
      css={css`
        position: relative;
        &:not(:focus-within) {
          input {
            color: transparent;
          }
        }
        input:focus + div {
          display: none;
        }
      `}
    >
      {children}
      <InputDisplayValue>{value}</InputDisplayValue>
    </div>
  );
};
